import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {DialogService} from '../../../services/dialog.service';
import {CustomSnackBarService} from '../../../services/custom-snackbar.service';
import {BehaviorSubject} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {MatTableDataSource} from '@angular/material/table';
import {PurgeDomainJob} from '../../../models/reporting.model';
import {ReportingService} from '../../../services/reporting.service';
import {MatPaginator} from '@angular/material/paginator';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {extractErrorMessage} from '../../../utils/error-utils';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {UserService} from "../../../services/user.service";
import {MatTabGroup} from "@angular/material/tabs";

@Component({
  selector: 'app-reports-deleted-docs',
  templateUrl: './reports-deleted-docs.component.html',
  styleUrls: ['./reports-deleted-docs.component.scss']
})
export class ReportsDeletedDocsComponent implements OnInit, AfterViewInit {

  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public dataSource: MatTableDataSource<PurgeDomainJob>;
  public dataSourceFinra: MatTableDataSource<PurgeDomainJob>;
  public columns = ['deletionBatchId', 'executionDate', 'view', 'export'];
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  @ViewChild('standardPaginatorNoTabs') standardPaginatorNoTabs: MatPaginator;
  @ViewChild('standardPaginatorWithTabs') standardPaginatorWithTabs: MatPaginator;
  @ViewChild('finraPaginator') finraPaginator: MatPaginator;

  public showTabs: boolean = false;
  constructor(private userService: UserService,
              private reportingService: ReportingService,
              private dialogService: DialogService,
              private customSnackBarService: CustomSnackBarService,
              protected router: Router,
              private translate: TranslateService,
              private sanitizer: DomSanitizer,
              private iconRegistry: MatIconRegistry) {

    this.iconRegistry.addSvgIcon('view_data', this.sanitizer.bypassSecurityTrustResourceUrl('assets/img/view_data.svg'));
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource();
    this.dataSourceFinra = new MatTableDataSource();
    this.checkIfTabsNeeded();
  }

  ngAfterViewInit(): void {
    if (this.tabGroup) {
      this.tabGroup.selectedTabChange.subscribe(() => {
        // Wait for tab content to render and trigger the paginator setters
        setTimeout(() => {
          this.setupPaginators();
        });
      });

      // Setup initial paginators. This setTimeout is important because
      // the @ViewChild setters might not be triggered until after
      // ngAfterViewInit on initial load.
      setTimeout(() => {
        this.setupPaginators();
      });
    } else {
      // If no tabs, assign the single paginator immediately
      this.dataSource.paginator = this.standardPaginatorNoTabs;
    }
  }

  checkIfTabsNeeded(): void {
    this.showTabs = this.userService.isFinra();
    this.listPurgeDomainJob('STANDARD');
    if (this.showTabs) {
      this.listPurgeDomainJob('FINRA');
    }
  }

  private setupPaginators(): void {
    if (this.tabGroup) {
      if (this.tabGroup.selectedIndex === 0) {
        this.dataSource.paginator = this.standardPaginatorWithTabs;
      } else if (this.tabGroup.selectedIndex === 1) {
        this.dataSourceFinra.paginator = this.finraPaginator;
      }
    }
  }

  displayedColumns(): string[] {
    return this.columns;
  }

  viewDetails(deletionBatchId: string): void {
    const to = 'reports/deleted-documents/' + deletionBatchId;
    this.router.navigate([to]);
  }

  exportDeletedDocsForDomainJob(purgeDomainJob: string): void {
    this.reportingService.exportDeletedDocsForDomainJob(purgeDomainJob)
      .subscribe({
        next: () => this.customSnackBarService.openSuccessSnackbar(this.translate.instant('snackBarMessage.exportStarted')),
        error: (error) => this.dialogService.error(extractErrorMessage(error))
      });
  }

  disableDomainJobButton(): boolean {
    return !this.userService.isSuperAdmin();
  }

  listPurgeDomainJob(type: 'STANDARD' | 'FINRA'): void {
    this.loadingSubject.next(true);
    this.reportingService.listDomainPurgeJobs(type).pipe(
      finalize(() => this.loadingSubject.next(false))
    ).subscribe({
      next: (resp) => {
        const mappedData = resp.data.map(item => ({
          ...item,
          executionTime: Math.floor(item.executionTime) * 1000
        }));

        if (type === 'FINRA') {
          this.dataSourceFinra.data = mappedData;
          this.dataSourceFinra.paginator = this.finraPaginator;
        } else {
          this.dataSource.data = mappedData;
          this.dataSource.paginator = this.showTabs ? this.standardPaginatorWithTabs : this.standardPaginatorNoTabs;
        }

        this.setupPaginators();
      },
      error: (error) => {
        this.dialogService.error(extractErrorMessage(error));
      }
    });
  }
}
